import { useEffect } from 'react'
import { axiosInstance } from 'src/network/adapter'
import { ApiEndPoints } from 'src/network/endpoints'
import { registerGoodsCategoryLabels } from 'src/utils/logisticsLabels'

const GoodsCategoryLabelsBootstrap = () => {
  useEffect(() => {
    axiosInstance
      .get(ApiEndPoints.CATEGORY.list('cargo_type'))
      .then(response => {
        registerGoodsCategoryLabels(response?.data?.data?.categories || [])
      })
      .catch(() => {})
  }, [])

  return null
}

export default GoodsCategoryLabelsBootstrap
